export default __webpack_public_path__ + "static/media/868226267869245522.f2e263aa.png";